/* Felles logoregister for partnerdeckene. Offisielle SVG-er (monokrom via CSS-maske i blekkfargen) — brukes kun i private,
   passordbeskyttede forslag til selskapet selv. Ny mottaker = ny oppføring + SVG i /public/logos/partners/. */

export const LOGOS = {
  dnb: { name: "DNB", logo: "/logos/partners/dnb.svg", ar: 93.0362 / 64, scale: 1.55 },
  "sparebanken norge": { name: "Sparebanken Norge", logo: "/logos/partners/sparebanken-norge.svg", ar: 300 / 64, scale: 1.1 },
  telenor: { name: "Telenor", logo: "/logos/partners/telenor.svg", ar: 2026.4 / 862.7, scale: 1.25 },
  equinor: { name: "Equinor", logo: "/logos/partners/equinor.svg", ar: 402 / 160, scale: 1.25 },
  lovable: { name: "Lovable", logo: "/logos/partners/lovable.svg", ar: 755 / 129 },
  replit: { name: "Replit", logo: "/logos/partners/replit.svg", ar: 1122 / 318, scale: 1.1 },
  emergent: { name: "Emergent", logo: "/logos/partners/emergent.svg", ar: 112 / 24 },
  base44: { name: "Base44", logo: "/logos/partners/base44.svg", ar: 111 / 26 },
  "cms kluge": { name: "CMS Kluge", logo: "/logos/partners/cms-kluge.svg", ar: 109.1339 / 55.4173, scale: 1.75 },
  "schjødt": { name: "Schjødt", logo: "/logos/partners/schjodt.svg", ar: 80 / 22, scale: 1.1 },
  schjodt: { name: "Schjødt", logo: "/logos/partners/schjodt.svg", ar: 80 / 22, scale: 1.1 },
  thommessen: { name: "Thommessen", logo: "/logos/partners/thommessen.svg", ar: 196.7 / 23.6, scale: 0.9 },
  wiersholm: { name: "Wiersholm", logo: "/logos/partners/wiersholm.svg", ar: 408 / 151, scale: 1.5 },
  bahr: { name: "BAHR", logo: "/logos/partners/bahr.svg", ar: 841.01 / 120.28, scale: 0.95 },
  "wikborg rein": { name: "Wikborg Rein", logo: "/logos/partners/wikborg-rein.svg", ar: 261 / 28, scale: 0.9 },
  selmer: { name: "Selmer", logo: "/logos/partners/selmer.svg", ar: 301 / 76, scale: 1.15 },
  haavind: { name: "Haavind", logo: "/logos/partners/haavind.svg", ar: 220 / 50, scale: 1.1 },
  openai: { name: "OpenAI", logo: "/logos/partners/openai.svg", ar: 269.6592 / 72.5157, scale: 1.05 },
  microsoft: { name: "Microsoft", logo: "/logos/partners/microsoft.svg", ar: 337.6 / 72, scale: 1.05 },
  google: { name: "Google", logo: "/logos/partners/google.svg", ar: 272 / 92, scale: 1.3 },
  unite: { name: "Unite", logo: "/logos/unite.svg", ar: 688 / 244, scale: 1.15 },
  apriil: { name: "Apriil", logo: "/logos/apriil.svg", ar: 126 / 23, scale: 0.95 },
  cure: { name: "Cure", logo: "/logos/cure.svg", ar: 96 / 27, scale: 1.0 },
  grieghallen: { name: "Grieghallen", logo: "/logos/grieghallen.svg", ar: 55 / 5, scale: 0.6 },
  anthropic: { name: "Anthropic", logo: "/logos/partners/anthropic.svg", ar: 1024.2 / 115, scale: 0.85 },
  meta: { name: "Meta", logo: "/logos/partners/meta.svg", ar: 948 / 191, scale: 1.15 },
  aws: { name: "AWS", logo: "/logos/partners/aws.svg", ar: 304 / 182, scale: 2.1 },
  /* Presenting Partner-kandidater (Thorsteins liste). Offisielle vektorlogoer (Wikimedia Commons / selskapets nettsted); Fearnleys kun PNG. Kongsberg: skjoldmerke egner seg ikke som maske → tekst. */
  aker: { name: "Aker", logo: "/logos/partners/aker.svg", ar: 145.28 / 140.25, scale: 1.6 },
  "aker asa": { name: "Aker", logo: "/logos/partners/aker.svg", ar: 145.28 / 140.25, scale: 1.6 },
  wilhelmsen: { name: "Wilhelmsen", logo: "/logos/partners/wilhelmsen.svg", ar: 1.325, scale: 1.5 },
  "høegh": { name: "Höegh", logo: "/logos/partners/hoegh.svg", ar: 4.0, scale: 0.95 },
  "höegh": { name: "Höegh", logo: "/logos/partners/hoegh.svg", ar: 4.0, scale: 0.95 },
  hoegh: { name: "Höegh", logo: "/logos/partners/hoegh.svg", ar: 4.0, scale: 0.95 },
  mckinsey: { name: "McKinsey", logo: "/logos/partners/mckinsey.svg", ar: 8.0, scale: 1.05 },
  "mckinsey & company": { name: "McKinsey", logo: "/logos/partners/mckinsey.svg", ar: 8.0, scale: 1.05 },
  "boston consulting group": { name: "Boston Consulting Group", logo: "/logos/partners/bcg.svg", ar: 2.371, scale: 1.1 },
  bcg: { name: "Boston Consulting Group", logo: "/logos/partners/bcg.svg", ar: 2.371, scale: 1.1 },
  arkwright: { name: "Arkwright", logo: "/logos/partners/arkwright.svg", ar: 500 / 107, scale: 1.0 },
  ey: { name: "EY", logo: "/logos/partners/ey.svg", ar: 68.67 / 69.32, scale: 1.5 },
  deloitte: { name: "Deloitte", logo: "/logos/partners/deloitte.svg", ar: 5.234, scale: 1.0 },
  hydro: { name: "Hydro", logo: "/logos/partners/hydro.svg", ar: 1.0, scale: 1.6 },
  "norsk hydro": { name: "Hydro", logo: "/logos/partners/hydro.svg", ar: 1.0, scale: 1.6 },
  nammo: { name: "Nammo", logo: "/logos/partners/nammo.svg", ar: 4.92, scale: 1.0 },
  clarksons: { name: "Clarksons", logo: "/logos/partners/clarksons.svg", ar: 3824.64 / 616.04, scale: 0.95 },
  fearnleys: { name: "Fearnleys", logo: "/logos/partners/fearnleys.png", ar: 371 / 70, scale: 1.0 },
  nhh: { name: "NHH", logo: "/logos/partners/nhh.svg", ar: 167 / 87, scale: 1.2 },
  /* Quantum Partner-kandidater. D-Wave: ordmerket (Wikimedia Commons, PD), viewBox beskåret uten «The Quantum Computing Company». */
  "d-wave": { name: "D-Wave", logo: "/logos/partners/d-wave.svg", ar: 25.645694 / 3.25, scale: 0.95 },
  dwave: { name: "D-Wave", logo: "/logos/partners/d-wave.svg", ar: 25.645694 / 3.25, scale: 0.95 },
  "d-wave quantum": { name: "D-Wave", logo: "/logos/partners/d-wave.svg", ar: 25.645694 / 3.25, scale: 0.95 },
};

export const logoOf = (name) => LOGOS[(name || "").trim().toLowerCase()] || null;

/* Logo i blekkfargen via maske (h = høyde i canvas-px, skalert per logo så kompakte merker ikke blir små) — eller navnet som tekst */
export const Wordmark = ({ name, h = 44, className = "" }) => {
  const l = logoOf(name);
  if (!l) return <b className={`hd-wm-text ${className}`} data-testid="hd-wordmark-text">{name}</b>;
  return (
    <span
      className={`hd-wm-logo ${className}`}
      role="img"
      aria-label={name}
      style={{ "--logo": `url(${l.logo})`, "--ar": l.ar, "--h": `${Math.round(h * (l.scale || 1))}px` }}
      data-testid="hd-wordmark-logo"
    />
  );
};

/* Logoen som rolig objekt i høyre kolonne på «Why <mottaker>»-slides */
export const LogoStamp = ({ name, sub }) => {
  const l = logoOf(name);
  return (
    <figure className={`hd-logo-stamp ${l ? "" : "text"}`} data-testid="hd-logo-stamp">
      <Wordmark name={name} h={l ? 120 : 0} />
      {sub && <figcaption>{sub}</figcaption>}
    </figure>
  );
};
